module.exports = __webpack_public_path__ + "img/goldregen-2020-035.769b1dcf.jpg";